import { Clickable } from '@carvana/merch-components';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useModalContext } from '~/context/vdp/ModalContext/ModalContext';
import { getVehicleDetails } from '~/selectors';
import useSelector from '~/store/useSelector';
import {
  CardContainer,
  CardSVG,
  CardTitle,
  List,
  ListItem
} from './CategoryCard.styles';

type OwnProps = {
  inModal?: 'inKeyFeaturesModal' | 'inFeatureAndSpecModal';
};

export default function InstalledPackagesCard({ inModal }: OwnProps) {
  const isOnPage = !inModal;
  const inKeyFeaturesModal = inModal === 'inKeyFeaturesModal';
  const { setFeaturesAndSpecsModalOpen } = useModalContext();
  const { installedPackages = [] } = useSelector(getVehicleDetails);
  const isMobile = useIsMobile();

  return (
    <CardContainer onPage={isOnPage}>
      <CardSVG
        alt="Installed Packages"
        src={`${
          process.env.CVNA_APP_CDN_ASSETS_PATH
        }/svgs/cvna-category/installed-packages-${
          isMobile ? '32' : '56'
        }px.svg`}
      />
      <div>
        <CardTitle biggerTitle={inKeyFeaturesModal}>
          Installed Packages
        </CardTitle>
        <List>
          {installedPackages.map(pack => (
            <ListItem key={pack.name}>{pack.name}</ListItem>
          ))}
        </List>

        <Clickable
          data-analytics-id="Key Features - Installed Packages"
          className="mt-xl w-fit text-blue-2 tl-label-m"
          onClick={() => setFeaturesAndSpecsModalOpen(true, true)}
        >
          Details
        </Clickable>
      </div>
    </CardContainer>
  );
}
